var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.59998 12.1333V8.80001H3.86665V10.4667L1.33331 8.00001L3.86665 5.46668V8.00001H7.59998V3.86668H5.46665L7.99998 1.33334L10.5333 3.86668H8.46665V8.00001H12.2V5.46668L14.6666 8.00001L12.1333 10.5333V8.86668H8.39998V12.2H10.4666L7.99998 14.6667L5.46665 12.1333H7.59998Z",
    fill: "#11788F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMove);
export default __webpack_public_path__ + "static/media/move.2c3238a2d343c6114e525470bc95d596.svg";
export { ForwardRef as ReactComponent };